// tslint:disable-next-line:ordered-imports
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '@pipes/pipes.module';
import { ServicesModule } from '@services/services.module';


// Maquetacion-añadido para funcionalidad del hbs-toolcard
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { TitlePageComponent } from './title-page/title-page.component';
import { MessagesComponent } from './messages/messages.component';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';


/**
 * Modulo que incorpora todas las funcionalidaeds del layout general de la página.
 * Pagina 404
 * Página de errores
 * Página 500
 * Header
 * Footer
 */
@NgModule({
  imports: [
    PipesModule,
    CommonModule,
    FormsModule,
    ServicesModule,
    RouterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  entryComponents: [
  ],
  providers: [
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    MenuComponent,
    TitlePageComponent,
    MessagesComponent
],
  exports: [
    HeaderComponent,
    FooterComponent,
    TitlePageComponent,
    MessagesComponent,
    MenuComponent
  ],
})
export class LayoutModule {
  constructor() {

  }
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

